import { z } from "zod";

/**
 * Shape of an audit_log row returned to the dashboard. Mirror of the D1
 * table, but with the raw prompt/response kept as strings (not parsed)
 * so the frontend can pretty-print them in the viewer.
 */
export const AuditRowZ = z.object({
  id: z.number().int(),
  requestId: z.string(),
  tier: z.enum(["haiku", "sonnet"]),
  pairId: z.string(),
  accountId: z.string().nullable(),
  firmId: z.string(),
  firmRulesVersion: z.string(),
  firmRulebookHash: z.string(),
  requestedAction: z.string().nullable(),
  claudeAction: z.string(),
  complianceStatus: z.string().nullable(),
  violationDetail: z.string().nullable(),
  rulesChecked: z.string().nullable(), // JSON-encoded array
  reason: z.string(),
  confidence: z.number().nullable(),
  ragChunkIds: z.string().nullable(), // JSON-encoded array
  rawPrompt: z.string(),
  rawResponse: z.string(),
  usageInput: z.number().int().nullable(),
  usageCacheRead: z.number().int().nullable(),
  usageCacheWrite: z.number().int().nullable(),
  usageOutput: z.number().int().nullable(),
  costUsd: z.number().nullable(),
  executed: z.number().int(),
  createdAt: z.number().int(),
});
export type AuditRow = z.infer<typeof AuditRowZ>;

export const AuditFeedQueryZ = z.object({
  pairId: z.string().optional(),
  firmId: z.string().optional(),
  tier: z.enum(["haiku", "sonnet"]).optional(),
  complianceStatus: z.enum(["compliant", "warning", "violation"]).optional(),
  before: z.number().int().optional(), // createdAt cursor
  limit: z.number().int().min(1).max(200).default(50),
});
export type AuditFeedQuery = z.infer<typeof AuditFeedQueryZ>;

export const AuditFeedResZ = z.object({
  rows: z.array(AuditRowZ),
  nextCursor: z.number().int().nullable(),
});
export type AuditFeedRes = z.infer<typeof AuditFeedResZ>;
